<template>
  <div class="wrap">
    <div class="title">
      <router-link :to="{ name: 'create-kokuban-detail', params: { cloudConstructionId: $route.params.cloudConstructionId } }">
        {{ currentConstruction.cloud_construction_name }}
      </router-link>
      ＞黒板確認
    </div>
    <div class="serial-wrap">
      <label>シリアルID:</label>
      <ValidationInput field-name="シリアルID"
                       :valid-rules="serialIdValidRules"
                       ref="serialIdInput">
        <input type="text" v-model="serialId" maxlength="8"
        @keyup="upcaseSerialId" @blur="upcaseSerialId" 
        />
      </ValidationInput>
      <button class="send-btn" @click="sendKokuban">工事黒板に送信</button>
    </div>
    <div class="search-wrap">
      <label>検索ワード:</label>
      <input type="text" v-model="keyword"/>
    </div>
    <div class="check-btn-wrap">
      <div class="all-deselect-btn-wrap">
        <button class="all-deselect-btn" @click="deselectAll">
          全選択解除
        </button>
      </div>
      <div class="all-select-btn-wrap">
        <button class="all-select-btn" @click="selectAll">
          全選択
        </button>
      </div>
      <div class="view-bookrack-btn-wrap">
        <button class="view-bookrack-btn" @click="openBookrackView">
          本棚確認
        </button>
      </div>
    </div>
    <div class="kokuban-data-wrap">
      <div v-for="(kokuban, idx) in filteredKokubans" :key="idx" class="kokuban-item">
        <div class="send-checkbox-wrap">
          <label>
            <input type="checkbox"
                   class="send-checkbox"
                   v-model="kokuban.checked"
                   :id="'kokuban_'+idx">
            <span class="checkbox-parts"
                  :class="{ checked: kokuban.checked }"></span>
          </label>
        </div>
        <div class="created-key-wrap">
          <label :for="'kokuban_'+idx">
            {{ kokuban.kokuban_info.cloud_kokuban_number }}
          </label>
        </div>
        <div class="kokuban-image-wrap">
          <img class="kokuban-image"
               :src="kokuban.image_url"
               @click="() => { previewUrl = kokuban.image_url; $refs.theKokubanPreviewDialog.show() }" />
        </div>
      </div>
    </div>
    <DialogPanel modal-name="kokuban-preview-dialog"
                 main-button-text="閉じる"
                 @main-button-click="() => { $refs.theKokubanPreviewDialog.hide() }"
                 ref="theKokubanPreviewDialog">
      <img class="dialog-image" :src="previewUrl">
    </DialogPanel>
  </div>
</template>

<script>
export default {
  name: 'Output',
  components: {
    DialogPanel: () => import('@/components/ui/DialogPanel.vue'),
    ValidationInput: () => import('@/components/ui/ValidationInput')
  },
  props: {
    currentConstruction: Object,
    kokubanDataList: Array
  },
  data() {
    return {
      serialId: '',
      kokubans: [],
      previewUrl: '',
      keyword: '',
      serialIdValidRules: {
        required: true,
        regex: /^([A-Z]|[0-9]){8}$/
      }
    }
  },
  methods: {
    /** シリアルIDを大文字に変換する */
    upcaseSerialId(){
      this.serialId = this.serialId.toUpperCase();
    },
    /** 工事黒板に送信する */
    sendKokuban() {
      if (!this.$refs.serialIdInput || !this.$refs.serialIdInput.$children[0].flags.valid) {
        alert('シリアルIDの入力を確認してください。');
        return;
      }
      let kokuban_id_list = [];
      this.kokubans.forEach(kokuban => {
        if (kokuban.checked) {
          kokuban_id_list.push(kokuban.kokuban_id);
        }
      });
      if (kokuban_id_list.length === 0) {
        alert('送信する黒板データを選択してください。');
        return;
      }
      // 黒板データ作成・送信
      const args = {
        serial_id: this.serialId,
        cloud_construction_id: this.$route.params.cloudConstructionId,
        created_key_list: kokuban_id_list
      }
      this.$store.dispatch('api/makeKokubanData', args).then(() => {
        if (this.$store.getters['api/apiError']) {
          return;
        }
        if (this.$store.getters['api/result/sentKokubanWithTimeout']){
          alert('黒板送信登録しました。工事黒板に黒板が届くまで、１分程度お待ち下さい。');
          return;
        }
        alert('黒板データを送信しました。');
      });
    },
    /** チェック全選択 */
    selectAll() {
      // 表示されている黒板に対して行う
      const desplayedKokubans = this.filterKokubans();
      desplayedKokubans.forEach(kokuban => {
        kokuban.checked = true;
      });
    },
    /** チェック全選択解除 */
    deselectAll() {
      // 表示されている黒板に対して行う
      const desplayedKokubans = this.filterKokubans();
      desplayedKokubans.forEach(kokuban => {
        kokuban.checked = false;
      });
    },
    /** クラウド黒板Noでソート */
    compareKokubanNumber(a, b) {
      const kokubanNumberA = a.kokuban_info.cloud_kokuban_number;
      const kokubanNumberB = b.kokuban_info.cloud_kokuban_number;

      let comparison = 0;
      if (kokubanNumberA > kokubanNumberB) {
        comparison = 1;
      } else if (kokubanNumberA < kokubanNumberB) {
        comparison = -1;
      }
      return comparison;
    },
    /** 黒板を検索ワードで絞り込む */
    filterKokubans(){
      // 検索ワードが空欄であればすべての黒板を返す
      if (this.keyword === '') {
        return this.kokubans;
      }
      // 検索ワードで黒板を抽出する
      let filtered = [];
      for (let i in this.kokubans) {
        const kokuban = this.kokubans[i];

        // 黒板ナンバー、黒板のjsonのいずれかの要素に一致したらpush
        if (this.searchRecursive(kokuban.kokuban_info.cloud_kokuban_number, this.keyword)
         || this.searchRecursive(kokuban.kokuban_info.kokuban_param, this.keyword, ['value'])
         || this.searchRecursive(kokuban.organize_info, this.keyword)) {
          filtered.push(kokuban);
        }
      }
      return filtered;
    },
    /** 
     * 再帰的データ検索
     * @param data 検索対象となるデータ
     * @param word 検索する文字列
     * @param filter オブジェクトの検索対象に含めるキーをホワイトリストで指定する
     */
    searchRecursive(data, word, filter=null) {
      if (typeof data === 'string' && data !== null) {
        // 文字列なら検索
        if (data.indexOf(word) !== -1) {
          return true;
        }
      } else if (typeof data === 'object' && data !== null) {
        // オブジェクトならパラメータごとに再帰呼び出し
        for (let key in data) {
          if (filter !== null) {
            if (typeof data[key] === 'string' && !filter.includes(key)) {
              // 検索対象のキーに含まれていなければスキップ
              continue;
            }
          }
          if (this.searchRecursive(data[key], word, filter)) {
            return true;
          }
        }
      }
      return false;
    },
    /** 本棚ビューを開く */
    openBookrackView() {
      const bookrackViewUrl = process.env.VUE_APP_ORIGIN + '/bookrackview/index.html?id=' + this.currentConstruction.cloud_construction_id
      window.open(bookrackViewUrl, '_blank')
    }
  },
  computed: {
    filteredKokubans() {
      return this.filterKokubans();
    }
  },
  created() {
    // 黒板をソート
    this.kokubanDataList.sort(this.compareKokubanNumber);
    this.kokubanDataList.forEach(kokubanData => {
      let kokubanObj = {
        kokuban_id: kokubanData.kokuban_id,
        image_url: kokubanData.image_url,
        kokuban_info: kokubanData.kokuban_info,
        organize_info: kokubanData.organize_info,
        checked: false // TODO データ側で工事黒板に送信済かの状態を持つかも
      };
      this.kokubans.push(kokubanObj);
    });
  }
}
</script>

<style scoped>
.wrap {
  padding: 3rem;
}
.title {
  border-bottom: solid 1px #333;
  font-size: 1.4rem;
  font-weight: bold;
  padding: 2rem 1rem;
}
.title a {
  color: #333;
  cursor: pointer;
  text-decoration: none;
}
.title a:hover {
  opacity: 0.8;
}
.serial-wrap,
.search-wrap {
  padding: 2rem 1rem 0.5rem 1rem;
}
.serial-wrap *,
.search-wrap * {
  display: inline-block;
  vertical-align: middle;
}
/* シリアルID */
/* 検索ワード */
.serial-wrap input,
.search-wrap input {
  border: solid 2px #666;
  font-size: 1.1rem;
  padding: 1rem;
  margin: 0 1rem;
  text-align: center;
  width: 13rem;
}
/* 工事黒板送信ボタン */
.send-btn {
  background-color: #666;
  border: none;
  color: white;
  cursor: pointer;
  padding: 1rem 1.5rem;
}
/* 全選択ボタン */
/* 全選択解除ボタン */
/* 本棚確認ボタン */
.check-btn-wrap {
  margin: 1rem 0;
}
.check-btn-wrap * {
  display: inline-block;
  vertical-align: middle;
}
.all-select-btn-wrap,
.all-deselect-btn-wrap,
.view-bookrack-btn-wrap {
  padding: 0 1rem;
}
.all-select-btn,
.all-deselect-btn,
.view-bookrack-btn {
  background-color: #666;
  border: none;
  color: white;
  cursor: pointer;
  padding: 0.25rem 0;
  width: 124px;
}
.kokuban-data-wrap {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.kokuban-item {
  padding: 0.25rem 1.5rem;
  width: 220px;
  height: 220px;
}
/* 黒板画像 */
.kokuban-image-wrap {
  width: 100%;
  /* widthと同じにする 親(kokuban-item)の高さ - チェックボックスの高さ - 上下padding */
  height: calc(100% - 2rem - 0.5rem);
  text-align: center;
}
.kokuban-image {
  cursor: pointer;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.created-key-wrap {
  display: inline-block;
  font-size: 0.85rem;
  width: calc(100% - 2rem);
  vertical-align: top;
  line-height: 1.8rem;
  word-break : break-all;
}
/* チェックボックス */
.send-checkbox-wrap {
  display: inline-block;
  position: relative;
  height: 2rem;
  width: 2rem;
  vertical-align: top;
}
.send-checkbox {
  filter: alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  -webkit-appearance: none;
  appearance: none;
  position: absolute;
  z-index: 1;
}
.checkbox-parts {
  position:absolute;
  top: 0;
  left: 0;
  margin-bottom: 0.25rem;
}
.checkbox-parts::before {
  content: "";
  display: block;
  width: 1.5rem;
  height: 1.5rem;
  border: 1px solid #666;
  border-radius: 3px;
  background: #eee;
}
.send-checkbox:focus + .checkbox-parts::before {
  box-shadow: 0 0 0.4rem #333;
}
.checkbox-parts.checked::after {
  content: "";
  display: block;
  position: absolute;
  top: -5px;
  left: 4px;
  width: 1rem;
  height: 1.5rem;
  transform: rotate(40deg);
  border-bottom: 3px solid #555;
  border-right: 3px solid #555;
}
/* ダイアログ表示の画像 */
.dialog-image {
  max-width: 100%;
  height: auto;
}
</style>
<style>
[data-modal="kokuban-preview-dialog"] + div {
  text-align: center;
}
</style>